'use client';

import type { FC } from 'react';
import type { EnqueuedQuestionnaireItemProps } from './EnqueuedQuestionnaireItem.types';
import { Flex } from '@/_components';
import styles from './EnqueuedQuestionnaireItem.module.css';

export const EnqueuedQuestionnaireItem: FC<EnqueuedQuestionnaireItemProps> = ({
  questionnaire,
}) => {
  return (
    <div className={styles.item}>
      <Flex gap={4} isWrapping isYCentered>
        <span className={styles.templateName}>
          {questionnaire.template_name} ({questionnaire.tax_year}) for
        </span>
        <span className={styles.companyName}>{questionnaire.company_name}</span>
        {questionnaire.external_entity_id && (
          <span className={styles.entityId}>
            ({questionnaire.external_entity_id})
          </span>
        )}
      </Flex>
    </div>
  );
};
